import { render, staticRenderFns } from "./DarkNav.vue?vue&type=template&id=167709f4&scoped=true&"
import script from "./DarkNav.vue?vue&type=script&lang=js&"
export * from "./DarkNav.vue?vue&type=script&lang=js&"
import style0 from "./DarkNav.vue?vue&type=style&index=0&id=167709f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167709f4",
  null
  
)

export default component.exports